import { render, staticRenderFns } from "./CookieBanner.vue?vue&type=template&id=2e94828a&"
import script from "./CookieBanner.vue?vue&type=script&lang=js&"
export * from "./CookieBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e94828a')) {
      api.createRecord('2e94828a', component.options)
    } else {
      api.reload('2e94828a', component.options)
    }
    module.hot.accept("./CookieBanner.vue?vue&type=template&id=2e94828a&", function () {
      api.rerender('2e94828a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/CookieBanner.vue"
export default component.exports